module.exports = __webpack_public_path__ + "img/logo.fc5a6879.svg";